// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2du5x","row":"styles_row__2A8QK"};